import React from 'react'
import PrintHeaderSettings from './PrintHeaderSettings'
import PrintFooterSettings from './PrintFooterSettings'
import PrintBodySettings from './PrintBodySettings'
import { CustomInput } from 'src/consumer/components/helperComponents'
import PrintSidebarSettings from './PrintSidebarSettings'
import {
  getChangedNumberValueFromInput,
  getNumberStringForInput,
} from 'src/mentor/helpers/utilityFunctions'
import DocumentScanner from '@mui/icons-material/DocumentScanner'
import { Checkbox, FormControlLabel } from '@mui/material'
import {
  A4CustomMarginsContainer,
  InchesPlaceHolderDivStyles,
} from 'src/mentor/components/PrescriptionMakingPage/printComponents/styledComponents'

export default function PrintSettingFormItemComponent({
  printSetting,
  setPrintSetting,
  sectionTitle = 'Print Setting form',
}) {
  function setHeaderSettings(objOrPrev) {
    setPrintSetting((prev) => {
      if (typeof objOrPrev === 'function') {
        return { ...prev, headerSettings: objOrPrev(prev?.headerSettings || {}) }
      }
      return { ...prev, headerSettings: objOrPrev }
    })
  }

  function setBodySettings(objOrPrev) {
    setPrintSetting((prev) => {
      if (typeof objOrPrev === 'function') {
        return { ...prev, bodySettings: objOrPrev(prev?.bodySettings || {}) }
      }
      return { ...prev, bodySettings: objOrPrev }
    })
  }

  function setFooterSettings(objOrPrev) {
    setPrintSetting((prev) => {
      if (typeof objOrPrev === 'function') {
        return { ...prev, footerSettings: objOrPrev(prev?.footerSettings || {}) }
      }
      return { ...prev, footerSettings: objOrPrev }
    })
  }
  function setLeftSidebarSettings(objOrPrev) {
    setPrintSetting((prev) => {
      if (typeof objOrPrev === 'function') {
        return { ...prev, leftSidebarSettings: objOrPrev(prev?.leftSidebarSettings || {}) }
      }
      return { ...prev, leftSidebarSettings: objOrPrev }
    })
  }
  function setRightSidebarSettings(objOrPrev) {
    setPrintSetting((prev) => {
      if (typeof objOrPrev === 'function') {
        return { ...prev, rightSidebarSettings: objOrPrev(prev?.rightSidebarSettings || {}) }
      }
      return { ...prev, rightSidebarSettings: objOrPrev }
    })
  }

  return (
    <>
      <hr></hr>
      <div className="d-flex flex-column gap-1">
        <h5>{sectionTitle}</h5>
        
        {/* Use New Print Method setting - only for Paper Printing Settings */}
        {sectionTitle === 'Paper Printing Settings' && (
          <div className="d-flex flex-column gap-1 pt-2 pb-2">
            <FormControlLabel
              control={
                <Checkbox
                  checked={printSetting?.useNewPrintMethod ?? true}
                  onChange={(e) => {
                    setPrintSetting((prev) => ({
                      ...prev,
                      useNewPrintMethod: e.target.checked,
                    }))
                  }}
                />
              }
              label="Use New Print Method (Enable improved multi-page prescription printing with dynamic page breaking)"
            />
          </div>
        )}
        
        <div className="d-flex flex-column gap-2">
          <strong>
            Page Margin Settings (Adjust these on the basis of your browser print margins, keep 0
            for None, keep 0.4 for Default)
          </strong>
          <A4CustomMarginsContainer>
            <div />
            <CustomInput
              id="marginTop"
              value={getNumberStringForInput(printSetting?.marginTop)}
              type="number"
              onChange={(e) =>
                setPrintSetting((prev) => ({
                  ...prev,
                  [e.target.id]: getChangedNumberValueFromInput(e.target.value),
                }))
              }
              endIcon={<InchesPlaceHolderDivStyles>in</InchesPlaceHolderDivStyles>}
            />
            <div />
            <CustomInput
              id="marginLeft"
              value={getNumberStringForInput(printSetting?.marginLeft)}
              type="number"
              onChange={(e) =>
                setPrintSetting((prev) => ({
                  ...prev,
                  [e.target.id]: getChangedNumberValueFromInput(e.target.value),
                }))
              }
              endIcon={<InchesPlaceHolderDivStyles>in</InchesPlaceHolderDivStyles>}
            />
            <div className="d-flex justify-content-center align-items-center">
              <DocumentScanner sx={{ fontSize: '35px' }} />
            </div>
            <CustomInput
              id="marginRight"
              value={getNumberStringForInput(printSetting?.marginRight)}
              type="number"
              onChange={(e) =>
                setPrintSetting((prev) => ({
                  ...prev,
                  [e.target.id]: getChangedNumberValueFromInput(e.target.value),
                }))
              }
              endIcon={<InchesPlaceHolderDivStyles>in</InchesPlaceHolderDivStyles>}
            />
            <div />
            <CustomInput
              id="marginBottom"
              value={getNumberStringForInput(printSetting?.marginBottom)}
              type="number"
              onChange={(e) =>
                setPrintSetting((prev) => ({
                  ...prev,
                  [e.target.id]: getChangedNumberValueFromInput(e.target.value),
                }))
              }
              endIcon={<InchesPlaceHolderDivStyles>in</InchesPlaceHolderDivStyles>}
            />
            <div />
          </A4CustomMarginsContainer>
        </div>
        <br></br>
        <PrintHeaderSettings
          headerSettings={printSetting?.headerSettings}
          setHeaderSettings={setHeaderSettings}
        />
        <PrintSidebarSettings
          sidebarSettings={printSetting?.leftSidebarSettings}
          setSidebarSettings={setLeftSidebarSettings}
          headingText="Left Sidebar Settings"
        />
        <PrintSidebarSettings
          sidebarSettings={printSetting?.rightSidebarSettings}
          setSidebarSettings={setRightSidebarSettings}
          headingText="Right Sidebar Settings"
        />
        {/* <PrintBodySettings
          bodySettings={printSetting?.bodySettings}
          setBodySettings={setBodySettings}
        /> */}
        <PrintFooterSettings
          footerSettings={printSetting?.footerSettings}
          setFooterSettings={setFooterSettings}
        />
      </div>
    </>
  )
}

{
  /* <CustomInput
            value={getNumberStringForInput(printSetting?.marginRight)}
            label="Right margin in inches"
            type="number"
            onChange={(e) =>
              setPrintSetting((prev) => ({
                ...prev,
                marginRight: getChangedNumberValueFromInput(e.target.value),
              }))
            }
          />
          <CustomInput
            value={getNumberStringForInput(printSetting?.marginBottom)}
            label="Bottom margin in inches"
            type="number"
            onChange={(e) =>
              setPrintSetting((prev) => ({
                ...prev,
                marginBottom: getChangedNumberValueFromInput(e.target.value),
              }))
            }
          />
          <CustomInput
            value={getNumberStringForInput(printSetting?.marginLeft)}
            label="Left margin in inches"
            type="number"
            onChange={(e) =>
              setPrintSetting((prev) => ({
                ...prev,
                marginLeft: getChangedNumberValueFromInput(e.target.value),
              }))
            }
          /> */
}
